import { Box, Button, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';

import { IStatusModal } from '../../../../interfaces/modal.interface';

const StatusModal = ({ onClose, options }: { onClose: () => void; options: IStatusModal }) => {
  return (
    <Modal open={options.open}>
      <Box
        sx={{
          textAlign: 'center',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { sm: 600, xs: '100%' },
          bgcolor: '#ffffff',
          borderRadius: '1rem',
          boxShadow: 24,
          p: '2rem',
        }}
      >
        {options.icon}

        <Typography sx={{ fontSize: '1.75rem' }}>{options.heading}</Typography>

        <Typography sx={{ fontSize: '1rem', mb: '2rem' }}>{options.message}</Typography>

        <Button fullWidth sx={{ p: '1rem' }} variant='outlined' onClick={onClose} disableElevation>
          {options.buttonLabel}
        </Button>
      </Box>
    </Modal>
  );
};

export default StatusModal;
